import { useEffect, useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { v4 as uuid } from 'uuid';
import { observer, useNavigate } from '~/modules';
import { Routes } from '~/routes';
import { DOC_TYPES, base64ToBlob, showAlert, useStores } from '~/utils';
import OnboardingSignature from './OnboardingSignature';

const OnboardingSignatureContainer = () => {
  const [isConfirmButtonEnabled, setIsConfirmButtonEnabled] = useState(false);
  const navigate = useNavigate();
  const signatureRef = useRef<SignatureCanvas>(null);
  const { user } = useStores();
  const onClear = () => {
    setIsConfirmButtonEnabled(false);
    signatureRef.current?.clear();
  };

  const onEnd = () => {
    setIsConfirmButtonEnabled(true);
  };

  const handleConfirm = async () => {
    if (signatureRef.current?.isEmpty()) {
      showAlert({
        message: 'Faça sua assinatura antes de confirmar',
      });
      return;
    }

    const signatureData = signatureRef.current?.toDataURL();
    const blob = base64ToBlob(signatureData!);
    const payload = {
      uri: signatureData!,
      type: DOC_TYPES.SIGNATURE,
      name: `${uuid.v4()}.png`,
      mimeType: 'image/png',
      blob: blob,
    };
    await user.userImageValidation(payload);
    navigate(Routes.ONBOARDING_CONFIRMATION);
  };

  useEffect(() => {
    const resizeCanvas = () => {
      if (signatureRef.current) {
        const canvas = signatureRef.current.getCanvas();
        const { width, height } = canvas.getBoundingClientRect();

        canvas.width = width;
        canvas.height = height;

        signatureRef.current.clear();
      }
    };
    resizeCanvas();

    window.addEventListener('resize', resizeCanvas);
    window.addEventListener('orientationchange', resizeCanvas);

    return () => {
      window.removeEventListener('resize', resizeCanvas);
      window.removeEventListener('orientationchange', resizeCanvas);
    };
  }, []);

  return (
    <OnboardingSignature
      signatureRef={signatureRef}
      onClear={onClear}
      onConfirm={handleConfirm}
      isConfirmButtonEnabled={isConfirmButtonEnabled}
      onEnd={onEnd}
    />
  );
};

export default observer(OnboardingSignatureContainer);
